/**
 * 体育
 */
import React, {Component, PropTypes} from 'react'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {DOMAIN, SBSPORTS_RULES} from '../../constants/config'
import * as userAction from '../../actions/userAction'
import * as baseAction from '../../actions/baseAction'
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import SideBar from '../../components/affix/SideBar.jsx';
import TransferMoney from '../../components/modal/TransferMoney.jsx'

class Sports extends React.Component {

  constructor(props) {
    super(props);
    this.hideTransfer = this.hideTransfer.bind(this);
    this.refreshBalance = this.refreshBalance.bind(this);
    this.state = {
      display: false
    }
  }

  componentDidMount() {
    // 获取余额
    this.refreshBalance();
  }


  refreshBalance() {
    this.props.$$USER.getPlatformBalance('ibc');
  }

  openTransfer() {
    this.props.$$BASE.openOverlay();
    this.setState({
      display: true
    })
  }

  hideTransfer() {
    this.props.$$BASE.closeOverlay();
    this.setState({
      display: false
    })
  }

  render() {
    let __base = this.props.__BASE.toJS();
    let __user = this.props.__USER.toJS();

    return (
      <div className="sports-bg">
        <RichHeader />
        <SideBar />
        <div className="sport-container">
          <div className="content-box">
            <div className="header">
              <span className="title">
                <a href={SBSPORTS_RULES} target="_blank" className="sbsports-rules">
                  <i />
                  betting rules
                </a>
              </span>
              <a className="trasfer" onClick={this.openTransfer.bind(this)}>
                trasfer <i />
              </a>
              <a className="refresh" onClick={this.refreshBalance}>
                refresh <i />
              </a>
              <span className="balance">{_.round(__user.balance.ibc, 4).toFixed(4)}</span>
              <span className="text">balance：</span>
            </div>
            <div className="frame">
              <iframe width="100%" height="675px" src={DOMAIN + "ibcgame"} />
            </div>
          </div>
        </div>
        <MainFooter />
        <TransferMoney platform="ibc" display={this.state.display} hideFn={this.hideTransfer} />
      </div>
    );

  }
}

reactMixin(Sports.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$USER: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sports)